import { BaseBuildPart } from './base-build-part';
import { HelperParams } from './helper-params';
import { Category } from '../../documents';
import { DocumentsCategoriesBuildPart } from './documents-categories-build-part';

export class DocumentsBuildPart extends BaseBuildPart {
    constructor(private readonly documentsHelperParams: HelperParams,
                parent: BaseBuildPart,
                category: Category) {
        super(documentsHelperParams, parent, ['documents', category.categoryId]);
    }

    public category(category: Category) {
        return new DocumentsCategoriesBuildPart(this.documentsHelperParams, this, category);
    }
}